import { useContext } from 'react';

import { LayoutWrapContext } from '../../LayoutWrapContext';
import { LayoutWrapContextType } from '../../types/LayoutWrapContext';

export const useLayoutWrap = (): LayoutWrapContextType => {
  const layoutWrapContext = useContext(LayoutWrapContext);
  if (!layoutWrapContext) {
    throw new Error(
      'useLayoutWrap must be used within a LayoutWrapContext.Provider',
    );
  }

  return layoutWrapContext;
};
